// extracted by mini-css-extract-plugin
module.exports = {"actionBar":"CollectSubstituteRegistration_actionBar__3dW10"};